module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading full-character-formatting",
    attrs: {
      "epub:type": "chapter",
      "id": "vol-1-chapter-9",
      "role": "doc-chapter"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title case-upper"
  }, [_vm._v("9")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "vol-1-chapter-9-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width first-with-first-letter-t"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("T")]), _vm._v("hey made their way to an annex of the station, to a waiting room for members of the public, where Jennifer and their four-year-old daughter Merryn were waiting. The policeman escorting them nodded and left them at the entrance – two solid double doors.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I can’t go in just yet,” said Black, leaning against the wall. He took a deep breath, and closed his eyes in an effort to calm his nerves. In the space of just over two hours, his world had taken a dramatic change. Life, suddenly, had a tinge of the surreal.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“What the hell happened out there?” asked Fletcher, in a voice low, urgent.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Exactly what I said. Three guys, from nowhere.  Fucking crazies. With knives. Plus, one had a knuckleduster, if you can believe it.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Jesus,” said Fletcher. “I’d no idea Eaglesham was such a war zone. So much for sedate country living. You’d better tell me everything. In the morning. Only if you’re up to it, of course. Can’t blame you if you need to take some time off.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I’m fine. Just a little shaken. Nothing that a brandy can’t fix. Or ten.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Fletcher gave a short humourless laugh. “It’s been over fifteen years since I’ve walked into a police station. No idea if what I said was bullshit. Criminal law was never my "), _c('i', [_vm._v("pièce de resistance.")]), _vm._v(" But I think my performance was… passable. Especially the briefcase bit.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“More than passable.” Black grinned. “Bloody marvellous. You belong in the theatre. And thank you for the shoes. Though a bit tight.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Fletcher sniffed. “Beggars can’t be choosers. Plus, I want them back.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Of course you do.” Black frowned. “It was strange.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I haven’t been charged. They could have kept me in longer. It was almost as if they didn’t know what to do. Like they were waiting. They questioned me without the conversation being taped. Asking me questions without legal representation. They weren’t taking notes. Isn’t that a little odd?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“You’re asking me? Give me a commercial contract before a police interview any day.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Black gave a weary smile. “It’s been a long night. Thanks for coming. I didn’t know who else to call. You’re a good friend.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“You were attacked by three guys, and the cops have it all the wrong way around. It was the least I could do. You owe me big style, naturally.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Naturally. I expect nothing less. Another thing. Just a minor detail. Two of the attackers died.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Fletcher’s smile withered before him. His voice lowered to a rasping whisper. “Fucking one hell of a minor detail! Two guys dead?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“And the police mentioned the Grant family. You heard of them?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Fletcher visibly paled. He ran a fretful hand through his hair, his eyes blinking, as he computed the information.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“And you haven’t? Where have you been? The fucking moon? Their reputation is one of blood and carnage. Not the type who turn the other cheek, if the stories are true. Which they are. Heavy fucking gangsters. Without alarming you, but they’re mean bastards. To be avoided. Which is what you’ve not managed to do.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I’m now duly alarmed.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“So you should be.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Black took a deep breath. It was his turn to swear. “Fuck.”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f8418888","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vol001chapter009.vue
// module id = 99
// module chunks = 0